// extracted by mini-css-extract-plugin
export default {"hrefButton":"hrefButton-sqgWF","block":"block-zDoOt","primary":"primary-EiUDg","secondary":"secondary-iEND3","outline":"outline-mSzr2"};